export const MOCK_CURL_RESPONSE_GENERIC = {
  curl_req_response: {
    status: 200,
    statusText: 'Bad Request',
    body: { id: 1001, name: 'John Tan', email: 'john@gmail.com' }
    // body: { message: "Please provide valid parameters" }
  }
};

export const MOCK_CURL_RESPONSE_TOKEN = {
  curl_req_response: {
    status: 200,
    statusText: 'OK',
    body: {
      timestamp: '2026-05-18T13:18:42.110+00:00',
      status: 200,
      httpStatus: 'OK',
      data: {
        accessToken: 'eyJhbGciOiJIUzUxMiJ9.eyJyb2xlIjoiREVWRUxPUEVSX1BPUlRBTCIsInJvbGVfdHlwZSI6IkRldmVsb3BlciBBZG1pbiIsImxvZyI6IjMiLCJzZWN1cml0eVR5cGUiOiJudWxsIiwiZW1haWxJZCI6InhpdWp1bi55YW5nQGdtYWlsNC5jb20iLCJsb2NhbGUiOiJlbiIsInVzZXJLZXkiOiJmOGFmZWVkYy01YjcyLTQ4YTEtYmExNC05MDgwZDJkZGM2NmIiLCJ1c2VybmFtZSI6InhpdWp1bi55YW5nQGdtYWlsNC5jb20iLCJpYXQiOjE3NzkxMTAzMjIsInN1YiI6InhpdWp1bi55YW5nQGdtYWlsNC5jb20iLCJleHAiOjE3NzkxMTIxMjJ9.Gf8FfHxZvIhW4s2tif8wXMjfDyWDrMbxdrdBRFsiuuM1Ww0W4sgqAiMVznCqRX_YSc2yFel2J06xW0aDWLI6KQ',
        refreshToken: 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJ4aXVqdW4ueWFuZ0BnbWFpbDQuY29tIiwiaWF0IjoxNzc5MTEwMzIyLCJleHAiOjE3NzkxOTY3MjJ9.wQKZG55lR7TLNGlZSXDbTYuHTsXIO2irlZPAftHa2fYBQ-pxLA3-PUQVmZe6OwSo7G_SML6DbJL5TdwnnqLpxg',
        termsAccepted: null,
        menu: null,
        name: null
      },
      message: 'Login Successfully'
    }
  }
};

export const MOCK_API_RESPONSE_TOKEN = {
  "openapi": "3.0.1",
  "info": {
    "title": "Token API",
    "version": "1.0"
  },
  "servers": [
    {
      "url": "http://localhost:8080"
    }
  ],
  "paths": {
    "/auth/token": {
      "post": {
        "tags": [
          "Authentication"
        ],
        "summary": "Generate access token",
        "description": "Authenticate with credentials and receive a JWT access token for the Developer Portal",
        "operationId": "generateToken",
        "parameters": [
          {
            "name": "X-Request-Id",
            "in": "header",
            "required": false,
            "description": "Unique request tracking id",
            "schema": {
              "type": "string",
              "example": "REQ-10001"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/TokenRequest"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Token generated successfully",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/TokenResponse"
                }
              }
            }
          },
          "400": {
            "description": "Invalid request payload",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          },
          "401": {
            "description": "Invalid credentials",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          },
          "500": {
            "description": "Internal server error",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          }
        }
      }
    }
  },
  "components": {
    "schemas": {
      "TokenRequest": {
        "type": "object",
        "required": [
          "userName",
          "password",
          "app"
        ],
        "properties": {
          "userName": {
            "type": "string",
            "description": "Registered user email address",
            "example": "xiujun.yang@gmail4.com"
          },
          "password": {
            "type": "string",
            "description": "Account password",
            "example": "Pay10@1234"
          },
          "app": {
            "type": "string",
            "description": "Application identifier",
            "example": "DEVELOPER_PORTAL"
          }
        }
      },
      "TokenResponse": {
        "type": "object",
        "properties": {
          "accessToken": {
            "type": "string",
            "description": "JWT access token",
            "example": "eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ4aXVqdW4ueWFuZ0BnbWFpbDQuY29tIn0.signature"
          },
          "tokenType": {
            "type": "string",
            "description": "Token type",
            "example": "Bearer"
          },
          "expiresIn": {
            "type": "integer",
            "description": "Token expiry in seconds",
            "example": 3600
          }
        }
      },
      "ErrorResponse": {
        "type": "object",
        "properties": {
          "status": {
            "type": "integer",
            "description": "HTTP status code",
            "example": 400
          },
          "error": {
            "type": "string",
            "description": "Error type",
            "example": "Bad Request"
          },
          "message": {
            "type": "string",
            "description": "Detailed error message",
            "example": "userName is required"
          },
          "timestamp": {
            "type": "string",
            "description": "Time of the error",
            "example": "2024-05-18T10:30:00Z"
          },
          "path": {
            "type": "string",
            "description": "Request path that caused the error",
            "example": "/auth/token"
          }
        }
      }
    }
  }
}

export const MOCK_API_RESPONSE_GENERIC = {
  "openapi": "3.0.1",
  "info": {
    "title": "Developer Portal API",
    "version": "1.0"
  },
  "servers": [
    {
      "url": "http://localhost:8080"
    }
  ],
  "paths": {
    "/phone/{countryCode}/{phoneNumber}/validate": {
      "post": {
        "tags": [
          "Phone"
        ],
        "summary": "Validate phone number",
        "description": "Validate a phone number and return its country, format, and carrier details",
        "operationId": "validatePhoneNumber",
        "parameters": [
          {
            "name": "countryCode",
            "in": "path",
            "required": true,
            "description": "ISO 3166-1 alpha-2 country code",
            "schema": {
              "type": "string",
              "example": "IN"
            }
          },
          {
            "name": "phoneNumber",
            "in": "path",
            "required": true,
            "description": "Phone number in E.164 format",
            "schema": {
              "type": "string",
              "example": "+919876543210"
            }
          },
          {
            "name": "Authorization",
            "in": "header",
            "required": true,
            "description": "Bearer access token",
            "schema": {
              "type": "string",
              "example": "Bearer eyJhbGciOiJIUzI1NiJ9"
            }
          },
          {
            "name": "X-Request-Id",
            "in": "header",
            "required": true,
            "description": "Unique request tracking id",
            "schema": {
              "type": "string",
              "example": "REQ-20001"
            }
          },
          {
            "name": "format",
            "in": "query",
            "required": true,
            "description": "Response format for the phone number",
            "schema": {
              "type": "string",
              "example": "E164"
            }
          },
          {
            "name": "includeCarrier",
            "in": "query",
            "required": false,
            "description": "Whether to include carrier details in the response",
            "schema": {
              "type": "string",
              "enum": ["true", "false"],
              "example": "true"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/PhoneValidateRequest"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Phone number validated successfully",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PhoneValidateResponse"
                }
              }
            }
          },
          "400": {
            "description": "Invalid request payload",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          },
          "401": {
            "description": "Unauthorized request",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          },
          "500": {
            "description": "Internal server error",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          }
        }
      }
    }
  },
  "components": {
    "schemas": {
      "PhoneValidateRequest": {
        "type": "object",
        "required": ["phoneNumber"],
        "properties": {
          "phoneNumber": {
            "type": "string",
            "description": "Phone number to validate",
            "example": "9876543210"
          },
          "outputFormat": {
            "type": "string",
            "description": "Desired format for the returned phone number",
            "example": "E164",
            "enum": ["E164", "NATIONAL", "INTERNATIONAL", "RFC3966"]
          },
          "retryCount": {
            "type": "integer",
            "description": "Number of retry attempts on failure",
            "example": 3
          }
        }
      },
      "PhoneValidateResponse": {
        "type": "object",
        "properties": {
          "valid": {
            "type": "boolean",
            "description": "Whether the phone number is valid",
            "example": true
          },
          "phoneNumber": {
            "type": "string",
            "description": "Normalized E.164 formatted phone number",
            "example": "+919876543210"
          },
          "countryCode": {
            "type": "string",
            "description": "Detected country code",
            "example": "IN"
          },
          "countryName": {
            "type": "string",
            "description": "Detected country name",
            "example": "India"
          },
          "carrier": {
            "type": "string",
            "description": "Carrier name associated with the number",
            "example": "Jio"
          },
          "lineType": {
            "type": "string",
            "description": "Type of phone line",
            "example": "mobile"
          }
        }
      },
      "ErrorResponse": {
        "type": "object",
        "properties": {
          "status": {
            "type": "integer",
            "description": "HTTP status code",
            "example": 400
          },
          "error": {
            "type": "string",
            "description": "Error type",
            "example": "Bad Request"
          },
          "message": {
            "type": "string",
            "description": "Detailed error message",
            "example": "phoneNumber is required"
          },
          "timestamp": {
            "type": "string",
            "description": "Time of the error",
            "example": "2024-05-18T10:30:00Z"
          },
          "path": {
            "type": "string",
            "description": "Request path that caused the error",
            "example": "/phone/validate"
          }
        }
      }
    }
  }
};
